
const JiraBoardSection = () => {
  return (
    <div className="projects">
      <h4>Copy of Project's name Scrum Board</h4>
      <h1>Sprint 99</h1>
      <h3>QUICK FILTERS: </h3>
      <div className="status-header">
        <span>TO DO</span>
        <span>IN PROGRESS</span>
        <span>IN REVIEW</span>
        <span>DONE</span>
      </div>
    </div>
  );
};

export default JiraBoardSection;
